const selectValidator = (value, values) =>
  !values?.find((v) => v === value)
    ? "Selection did not match available options."
    : "";

const selectValidators = {
  selectValidator,
};

export default selectValidators;
